import { useEffect, useState } from 'react';
import { useGlobal } from './global';

export const useAgents = () => {
  const { fox } = useGlobal();
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!fox) {
      return;
    }

    setLoading(true);
    fox.call('GET', '/api/agents').then((out) => {
      setAgents(out.results);
      setLoading(false);
    });
  }, [fox]);

  return { agents, loading };
};
